var _excluded = ["classNames", "items", "hasRefinements"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cx } from 'instantsearch-ui-components';
import React from 'react';
import { capitalize, isModifierClick } from "./lib/index.js";
export function CurrentRefinements(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$hasRefinements = _ref.hasRefinements,
    hasRefinements = _ref$hasRefinements === void 0 ? false : _ref$hasRefinements,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('ais-CurrentRefinements', classNames.root, !hasRefinements && cx('ais-CurrentRefinements--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/React.createElement("ul", {
    className: cx('ais-CurrentRefinements-list', classNames.list, /* @MAJOR remove to ensure conformity with InstantSearch.css specs */
    !hasRefinements && cx('ais-CurrentRefinements-list--noRefinement', classNames.noRefinementList))
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: [item.indexName, item.label].join('/'),
      className: cx('ais-CurrentRefinements-item', classNames.item)
    }, /*#__PURE__*/React.createElement("span", {
      className: cx('ais-CurrentRefinements-label', classNames.label)
    }, capitalize(item.label), ":", ' '), item.refinements.map(function (refinement) {
      return /*#__PURE__*/React.createElement("span", {
        key: refinement.label,
        className: cx('ais-CurrentRefinements-category', classNames.category)
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('ais-CurrentRefinements-categoryLabel', classNames.categoryLabel)
      }, refinement.label), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick(event) {
          if (isModifierClick(event)) {
            return;
          }
          item.refine(refinement);
        },
        className: cx('ais-CurrentRefinements-delete', classNames.delete)
      }, "\u2715"));
    }));
  })));
}